import React from 'react';
import {
    LoginCardContainer,
    LoginCardHeadingWrapper,
    LoginCardHeadingText,
    LoginCardImageWrapper,
    EllipsesContainer,
    EllipsesIconWrapper,
    LoginCardImageInner,
    LoginButtonCtaWrapper,
    LoginButtonCtaText,
    LoginButtonCtaIcon,
} from './styles';
import { messages } from './messages';
import ChevronRightIcon from '@/assets/Icons/chevron_right.svg';
import LoginCardImage from '@/assets/Icons/login-card.svg';
import EllipsesIcon from '@/assets/Icons/ellipses.svg';
import { appendCurrentParamsToRoute } from '@/components/fakeDoor/utils';
import { getLoginUrl } from '@/utils/getLoginUrl';
import router from 'next/router';

interface LoginCardProps {
    loginCardTitle: string;
}

const LoginCard = ({ loginCardTitle }: LoginCardProps) => {
    const handleLoginClick = () => {
        const targetPath = router.asPath;
        const redirectPath = appendCurrentParamsToRoute(targetPath);
        window.location.href = getLoginUrl(redirectPath);
    };

    return (
        <LoginCardContainer>
            <LoginCardHeadingWrapper>
                <LoginCardHeadingText>
                    {loginCardTitle || messages.loginCardTitle}
                </LoginCardHeadingText>
                <LoginButtonCtaWrapper>
                    <LoginButtonCtaText onClick={handleLoginClick}>
                        {messages.loginCardButtonCta}
                    </LoginButtonCtaText>
                    <LoginButtonCtaIcon>
                        <ChevronRightIcon />
                    </LoginButtonCtaIcon>
                </LoginButtonCtaWrapper>
            </LoginCardHeadingWrapper>
            <LoginCardImageWrapper>
                <EllipsesContainer>
                    <EllipsesIconWrapper>
                        <EllipsesIcon />
                    </EllipsesIconWrapper>
                    <LoginCardImageInner>
                        <LoginCardImage />
                    </LoginCardImageInner>
                </EllipsesContainer>
            </LoginCardImageWrapper>
        </LoginCardContainer>
    );
};

export default LoginCard;
